import React, { useEffect, useState } from "react";
import { ArrowClockwise, X } from "@phosphor-icons/react";
import { applyUpdate } from "../swRegistration";
import { useConnectivity } from "../context/ConnectivityContext";

// Safe "update ready" banner. Defers reload while an expedition is active.
export default function UpdatePrompt() {
  const [reg, setReg] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const { isExpeditionActive } = useConnectivity();

  useEffect(() => {
    const onUpdate = (e) => { setReg(e.detail); setDismissed(false); };
    window.addEventListener("ff-sw-update", onUpdate);
    return () => window.removeEventListener("ff-sw-update", onUpdate);
  }, []);

  if (!reg || dismissed) return null;

  const active = isExpeditionActive?.();
  const doUpdate = () => {
    if (active) return; // never force reload mid-expedition
    applyUpdate(reg);   // triggers controllerchange -> single guarded reload
  };

  return (
    <div
      data-testid="update-prompt"
      className="fixed inset-x-3 bottom-16 z-[9996] mx-auto max-w-md rounded-md border border-ff-gold/40 bg-ff-bg2/95 p-4 shadow-xl backdrop-blur"
    >
      <div className="flex items-start gap-3">
        <ArrowClockwise size={22} weight="duotone" className="mt-0.5 text-ff-gold" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-ff-parchment">A new Aurumward update is ready.</p>
          {active && (
            <p className="mt-1 text-xs text-ff-brass" data-testid="update-deferred-note">
              We'll apply it once you finish your current expedition.
            </p>
          )}
          <div className="mt-3 flex gap-2">
            <button
              onClick={doUpdate}
              disabled={active}
              data-testid="update-now-btn"
              className="rounded-sm bg-ff-gold px-3 py-1.5 text-sm font-semibold text-ff-bg hover:bg-ff-brass disabled:opacity-50"
            >
              Update Now
            </button>
            <button
              onClick={() => setDismissed(true)}
              data-testid="update-later-btn"
              className="rounded-sm border border-ff-brass/30 px-3 py-1.5 text-sm text-ff-muted hover:text-ff-parchment"
            >
              Later
            </button>
          </div>
        </div>
        <button onClick={() => setDismissed(true)} className="text-ff-muted hover:text-ff-parchment" aria-label="Dismiss"><X size={16} /></button>
      </div>
    </div>
  );
}
